import { ConfirmButton } from "components/ConfirmButton"
import { TrashAlt } from "components/Icon"
import { useTranslator } from "components/Translator"
import { useRouter } from "components/Router"
import { useAsync } from "@react-hook/async"
import { Alerter } from "components/Alert"

export const BoatDeleteButton = ({ boat, onDelete, variant }) => {
  const translator = useTranslator()
  const router = useRouter()

  const [deleteBoatRequest, deleteBoat] = useAsync(async () => {
    const url = router.generate("app_user_boat_delete", { boatId: boat.id })

    try {
      const response = await fetch(url, {
        method: "DELETE",
        headers: { "X-Requested-With": "XMLHttpRequest" },
      })
      const responseData = await response.json()

      if (response.ok) {
        if (responseData.message) {
          Alerter.success(responseData.message)
        }

        onDelete?.(boat)
      } else {
        if (responseData.message) {
          Alerter.error(responseData.message)
        }
      }
    } catch (err) {
      console.error(err)
      Alerter.error(
        translator.trans("account.boat.index.delete.error", null, "pages"),
      )
    }
  })

  return (
    <ConfirmButton
      variant={variant}
      color="danger"
      iconLeft={<TrashAlt className="w-4" />}
      confirmTitle={translator.trans(
        "BoatDeleteButton.confirmTitle",
        null,
        "components",
      )}
      busy={deleteBoatRequest.status === "loading"}
      confirmContent={translator.trans(
        "BoatDeleteButton.confirmContent",
        null,
        "components",
      )}
      confirmLabel={translator.trans(
        "BoatDeleteButton.confirmLabel",
        null,
        "components",
      )}
      onConfirm={deleteBoat}
    >
      {translator.trans("BoatDeleteButton.cta", null, "components")}
    </ConfirmButton>
  )
}
